import React from 'react';
import { Calendar, List } from 'lucide-react';
import { cn } from '../../lib/utils';

interface TimelineControlsProps {
  viewMode: 'timeline' | 'list';
  onViewChange: (mode: 'timeline' | 'list') => void;
}

const TimelineControls: React.FC<TimelineControlsProps> = ({
  viewMode,
  onViewChange
}) => {
  return (
    <div className="flex bg-wedding-bg rounded-lg p-1 border border-wedding-pink/30">
      <button 
        className={cn(
          "px-4 py-2 rounded-md transition-all duration-200 flex items-center gap-2",
          viewMode === 'timeline' 
            ? 'bg-wedding-pink text-white shadow-sm' 
            : 'text-wedding-text-body hover:text-wedding-pink hover:bg-wedding-pink/10'
        )}
        onClick={() => onViewChange('timeline')}
      >
        <Calendar className="w-4 h-4" />
        <span className="hidden sm:inline">時間軸</span>
      </button>
      <button 
        className={cn(
          "px-4 py-2 rounded-md transition-all duration-200 flex items-center gap-2",
          viewMode === 'list' 
            ? 'bg-wedding-pink text-white shadow-sm' 
            : 'text-wedding-text-body hover:text-wedding-pink hover:bg-wedding-pink/10'
        )}
        onClick={() => onViewChange('list')}
      >
        <List className="w-4 h-4" />
        <span className="hidden sm:inline">列表</span>
      </button>
    </div>
  );
};

export default TimelineControls;